// rh-footer/rh-footer-copyright.js
import { createComponent } from '@lit/react';
import react from 'react';
import { RhFooterCopyright } from '@rhds/elements/rh-footer/rh-footer-copyright.js';
export const FooterCopyright = createComponent({
  tagName: 'rh-footer-copyright',
  elementClass: RhFooterCopyright,
  react,
  events: {},
});
